var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4827 23.7587L24.6292 24.6292L23.7589 21.4827C24.5437 20.2746 25 18.8332 25 17.2852C25 13.0243 21.546 9.57031 17.2852 9.57031C13.0243 9.57031 9.57031 13.0243 9.57031 17.2852C9.57031 21.546 13.0243 25 17.2852 25C18.8332 25 20.2746 24.5437 21.4827 23.7587Z",
    fill: "#2A51FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54688 0L5.64062 9.5459L9.54688 19.0918C14.8105 19.0918 19.0928 14.8096 19.0928 9.5459C19.0928 4.28223 14.8105 0 9.54688 0Z",
    fill: "#10BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5459C0 11.2614 0.456641 12.9316 1.32373 14.398L0.0350586 19.0565L4.69375 17.7681C6.16016 18.6352 7.83042 19.0918 9.5459 19.0918V0C4.28223 0 0 4.28223 0 9.5459Z",
    fill: "#5AECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8125 13.2324H10.2773V14.6973H8.8125V13.2324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81445 9.98022V11.7676H9.54688L10.0352 10.5387L9.54688 9.30977L8.81445 9.98022ZM6.61719 7.32422H8.08203C8.08203 6.51646 8.73911 5.85938 9.54688 5.85938L10.0352 5.12695L9.54688 4.39453C7.93135 4.39453 6.61719 5.70869 6.61719 7.32422Z",
    fill: "#292C32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54688 4.39453V5.85938C10.3546 5.85938 11.0117 6.51646 11.0117 7.32422C11.0117 7.74023 10.8423 8.12417 10.5349 8.40552L9.54688 9.30981V11.7676H10.2793V10.6252L11.5238 9.48618C12.1292 8.93213 12.4766 8.14419 12.4766 7.32422C12.4766 5.70869 11.1624 4.39453 9.54688 4.39453Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.00bf106b54d2084d91da0c8a70925cfb.svg";
export { ForwardRef as ReactComponent };